import React from 'react';

import * as styles from './styles/styles.module.scss';

type StarProps = {
  active: boolean;
};

const Star = ({ active }: StarProps): JSX.Element => {
  const className = active ? styles.active : styles.inactive;

  return (
    <svg className={className} role="img" width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 12L3.29772 14.4721L4.19577 9.23607L0.391548 5.52786L5.64886 4.76393L8 0L10.3511 4.76393L15.6085 5.52786L11.8042 9.23607L12.7023 14.4721L8 12Z"
      />
    </svg>
  );
};

export default Star;
